import { FormControl } from "@angular/forms";
const CPF = require('cpf')

export function cpfValidator(control: FormControl) {
    const value = control.value;
    if (value && !CPF.isValid(value)) {
        return { cpf: true };
    }
    return null;
}

